module.exports = __webpack_public_path__ + "img/SmartCommunity.ec24217d.png";